import { render, staticRenderFns } from "./listTable.vue?vue&type=template&id=527dda43&scoped=true"
import script from "./listTable.vue?vue&type=script&lang=js"
export * from "./listTable.vue?vue&type=script&lang=js"
import style0 from "./listTable.vue?vue&type=style&index=0&id=527dda43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527dda43",
  null
  
)

export default component.exports